import { Theme } from "@mui/material/styles";
import { SystemStyleObject } from "@mui/system";
import { PropsWithChildren } from "react";

import { Paper } from "@tsp/tsp-frontend-components/mui";

type Variant = "content" | "table";

type Props = PropsWithChildren<{
  variant: Variant;
  sx?: SystemStyleObject<Theme>;
}>;

const variantToPadding = (variant: Variant, values: Array<number | string>) => {
  switch (variant) {
    case "table":
      return values[0];
    case "content":
      return values[1];
    default:
      return 0;
  }
};

const variantToBorderRadius = (variant: Variant) => {
  if (variant === "table") {
    return {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
    };
  }

  return {};
};

export function Block({ variant, children, sx }: Props) {
  return (
    <Paper
      elevation={0}
      sx={
        [
          (theme: Theme) => ({
            width: 1808,
            mx: "auto",
            maxWidth: "100%",
            marginBottom: theme.spacing(3),
            padding: variantToPadding(variant, [0, theme.spacing(4)]),
            ...variantToBorderRadius(variant),
          }),
          sx,
        ] as any
      }
    >
      {children}
    </Paper>
  );
}
